export default __webpack_public_path__ + "static/automate-dont-2-dark-04c5eaab74af3d5c74949d2f0e6cfee8.png";